import { fetchApiData } from "../../utils/utils";

export const fetchActivity = async (appInfo, params = null) => {
    const api = `user/activity`;
    return await fetchApiData(appInfo, api, params);
};
